export default "__VITE_ASSET__BrxoWI47__"